import type { Form2086Entry } from './cgi150vhbis';

/**
 * Exporte les données du formulaire 2086 au format CSV.
 * Les colonnes correspondent aux cases officielles du formulaire 2086
 * (Article 150 VH bis du CGI).
 */
export const exportForm2086 = (entries: Form2086Entry[], year: number): void => {
  const headers = [
    '211 - Date de cession',
    'Actif cédé',
    'Quantité',
    '212 - Valeur portefeuille (€)',
    '213 - Prix cession brut (€)',
    '214 - Frais cession (€)',
    '217 - Prix cession net (€)',
    '220 - Total acquisitions (€)',
    '221 - Capital récupéré avant (€)',
    '222 - Soultes (€)',
    '223 - Acquisition nette (€)',
    '224 - Plus-value (€)',
  ];

  const rows = entries.map((e) => [
    new Date(e.case211).toLocaleDateString('fr-FR'),
    `${e.crypto.name} (${e.crypto.symbol})`,
    e.amountSold.toFixed(8),
    e.case212.toFixed(2),
    e.case213.toFixed(2),
    e.case214.toFixed(2),
    e.case217.toFixed(2),
    e.case220.toFixed(2),
    e.case221.toFixed(2),
    e.case222.toFixed(2),
    e.case223.toFixed(2),
    e.case224.toFixed(2),
  ]);

  // Totaux
  const totalSales = entries.reduce((sum, e) => sum + e.case217, 0);
  const totalGains = entries.reduce((sum, e) => sum + e.case224, 0);
  const flatTax = totalGains > 0 ? totalGains * 0.314 : 0; // 31.4% depuis janvier 2026

  rows.push(['TOTAL', '', '', '', '', '', totalSales.toFixed(2), '', '', '', '', totalGains.toFixed(2)]);
  rows.push(['', '', '', '', '', '', '', '', '', '', '', '']);
  rows.push(['INFORMATIONS FISCALES', '', '', '', '', '', '', '', '', '', '', '']);
  rows.push(['Plus-values totales', totalGains >= 0 ? totalGains.toFixed(2) : '0.00', '', '', '', '', '', '', '', '', '', '']);
  rows.push(['Moins-values totales', totalGains < 0 ? Math.abs(totalGains).toFixed(2) : '0.00', '', '', '', '', '', '', '', '', '', '']);
  rows.push(['Impôt forfaitaire (31.4%)', flatTax.toFixed(2), '', '', '', '', '', '', '', '', '', '']);

  const csvContent = [
    headers.join(','),
    ...rows.map((row) => row.map((cell) => `"${cell}"`).join(',')),
  ].join('\n');

  const bom = '\uFEFF';
  const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', `formulaire_2086_${year}.csv`);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};
